var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row full-height" }, [
    _c(
      "div",
      {
        ref: "scrolllist",
        staticClass: "col scroll col-no-padding list-col",
        staticStyle: { height: "calc(100% - 40px)" },
        on: { scroll: _vm.handleScroll },
      },
      [
        _c(
          "div",
          { staticClass: "row library-list px-2" },
          _vm._l(_vm.filteredlist, function (ap, key, indexAP) {
            return _c(
              "div",
              { key: key, staticClass: "col-6 col-xl-4 mb-3 px-2" },
              [
                _c(
                  "CardImage",
                  {
                    class: { selected: ap.selected },
                    nativeOn: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.toggleSelect(ap)
                      },
                    },
                  },
                  [
                    _c("div", {
                      staticClass: "image",
                      style: _vm.picture(ap),
                      attrs: { slot: "image" },
                      slot: "image",
                    }),
                    _vm._v(" "),
                    _vm.hasPlans(ap) || _vm.hasPatrols(ap)
                      ? _c(
                          "div",
                          {
                            staticClass: "action",
                            attrs: { slot: "action" },
                            on: {
                              mouseover: function ($event) {
                                return _vm.showTooltip(ap)
                              },
                              mouseout: _vm.closeTooltip,
                            },
                            slot: "action",
                          },
                          [
                            _vm.hasPlans(ap)
                              ? _c("i", { staticClass: "fa fa-map" })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.hasPatrols(ap)
                              ? _c("i", { staticClass: "fa fa-history" })
                              : _vm._e(),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.hasPlans(ap) || _vm.hasPatrols(ap)
                      ? _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "on-clickaway",
                                rawName: "v-on-clickaway",
                                value: _vm.closeTooltip,
                                expression: "closeTooltip",
                              },
                            ],
                            staticClass: "tooltip right",
                            class: { show: ap.show },
                          },
                          [
                            _vm.hasPlans(ap)
                              ? [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$t("ap.library.plansDetail"))
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "ul",
                                    _vm._l(ap.plans, function (plan) {
                                      return _c("li", [
                                        _vm._v(_vm._s(plan.name)),
                                      ])
                                    }),
                                    0
                                  ),
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.hasPatrols(ap)
                              ? [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$t("ap.library.patrolDetail"))
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "ul",
                                    _vm._l(ap.patrols, function (patrol) {
                                      return _c("li", [_vm._v(_vm._s(patrol))])
                                    }),
                                    0
                                  ),
                                ]
                              : _vm._e(),
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "content" }, [
                      _c("div", { staticClass: "col-left" }, [
                        _c("i", { class: _vm.icons(ap.type) }),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-right" }, [
                        _c("strong", [_vm._v(_vm._s(ap.name))]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t(_vm.typeLabel(ap.type)))),
                        ]),
                      ]),
                      _vm._v(" "),
                      ap.type == 2 || ap.type == 4 || ap.type == 5
                        ? _c("div", { staticClass: "col-qrcode" }, [
                            ap.type == 4
                              ? _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "can",
                                        rawName: "v-can",
                                        value: "beepiz-readQRCode-library",
                                        expression:
                                          "'beepiz-readQRCode-library'",
                                      },
                                    ],
                                    staticClass: "qrcode-button",
                                    attrs: {
                                      title: _vm.$t(
                                        "ap.titles.modalQRCodeViewer"
                                      ),
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.showQRCodeViewer(ap)
                                      },
                                    },
                                  },
                                  [_c("i", { staticClass: "fa fa-eye" })]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            ap.type == 5 || ap.type == 2
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "battery-info",
                                    attrs: {
                                      title:
                                        ap.battery === null
                                          ? _vm.$t("ap.batteryNoInfo")
                                          : "",
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa",
                                      class: {
                                        "no-battery-info": ap.battery === null,
                                        "battery-ok fa-battery":
                                          ap.battery >= 2400,
                                        "battery-warning fa-battery-half":
                                          ap.battery >= 1700 &&
                                          ap.battery < 2400,
                                        "battery-ko fa-battery-empty":
                                          ap.battery < 1700,
                                      },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                          ])
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    ap.last_detection_at
                      ? _c("div", { staticClass: "text-muted text-sm mt-3" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.lastDetectionAt(
                                  ap.last_detection_at.date,
                                  ap.last_detection_at.timezone
                                )
                              ) +
                              "\n          "
                          ),
                        ])
                      : _vm._e(),
                  ]
                ),
              ],
              1
            )
          }),
          0
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }